import { PrismicRichText } from "@prismicio/react";
import React from 'react';

export const DataContent = (props) => {

    const sc = props.slice.primary;

    const repeat = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let grid = sc.columns

    if (grid === "one") {
        grid = "md:w-2/4 m-auto"
    } else if (grid === "two") {
        grid = "md:basis-1/2-gap-8"
    } else if (grid === "three") {
        grid = "md:basis-1/3-gap-8"
    } else {
        grid = "md:basis-1/4-gap-8";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    return (

        <section className={"data-content relative bg-" + (bg) + " " + (space)}>
            <div className="wrapper">
            {sc.section_title.text ? <div className="md:text-center md:w-3/4 md:m-auto mb-12 md:mb-16"><PrismicRichText field={sc.section_title.richText} /><PrismicRichText field={sc.section_content.richText} /></div> : ''}
          <div className="data-content flex flex-col md:flex-row flex-wrap justify-center gap-8">

            {repeat.map((card, index) => {
                return (
                    <div key={index} className={"w-full content-side-side relative flex flex-col justify-between mb-0 md:mb-8 " + (grid)}>
                        {sc.layout === "center" ? 
                            <div className={"flex md:flex-col text-left md:text-center items-center gap-3" + (card.icon.url ? ' md:gap-0' : ' px-0 ')}>
                                {card.icon.url ? <div className={"w-16 md:w-24 mb-0 md:mb-4 icon " +(card.theme)}><img src={card.icon.url} alt="" /></div> : ''}
                                
                                <div className={"min-w-fit text-2xl md:text-6xl font-black md:mb-2 text-" + (card.theme)}>{card.data_title}</div>
                                <PrismicRichText field={card.data_content.richText} components={components} />
                            </div>
                        : (sc.layout === "long" ? 
                            <div className={"flex flex-col md:flex-row gap-6 mb-3 md:justify-center" + (card.icon.url ? ' md:p-0' : ' px-0 md:px-4')}>
                                {card.icon.url ? <div className={"w-16 mb-0 md:mb-4 icon " +(card.theme)}><img src={card.icon.url} alt="" /></div> : ''}
                                <div className={"w-full" + (card.icon.url ? ' md:w-4/5' : '')}>
                                <div className={"min-w-fit text-xl md:text-2xl font-black mb-2 text-" + (card.theme)}>{card.data_title}</div>
                                <PrismicRichText field={card.data_content.richText} components={components} />
                                </div>
                            </div>
                        : (sc.layout === "left" ? 
                        <div className="flex flex-col mb-3 md:justify-center md:px-5">
                            {card.icon.url ? <div className={"w-16 md:w-18 mb-4 icon " +(card.theme)}><img src={card.icon.url} alt="" /></div> : ''}
                            <div className="w-full">
                            <div className={"min-w-fit text-xl md:text-2xl font-black mb-2 text-" + (card.theme)}>{card.data_title}</div>
                            <PrismicRichText field={card.data_content.richText} components={components} />
                            </div>
                        </div>
                    : 
                        <div className="flex flex-col md:flex-row gap-2 md:gap-6 md:justify-center px-0 md:px-2">
                            <div className={"min-w-fit text-4xl md:text-6xl font-black mb-0 text-" + (card.theme)}>{card.data_title}</div>
                            <PrismicRichText field={card.data_content.richText} components={components} />
                        </div>
                    ))}
                    </div>
                );
            })}

            
            

          </div>
        </div>
      </section>
    );
}

